import { render, staticRenderFns } from "./ActiveContracts.vue?vue&type=template&id=4f678bd6&"
import script from "./ActiveContracts.vue?vue&type=script&lang=ts&"
export * from "./ActiveContracts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports